module.exports = __webpack_public_path__ + "static/media/Organization_3.1c9bb9ae.svg";